import { gql } from '@apollo/client';

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`;

export const VERIFY_RESET_TOKEN = gql`
  mutation VerifyResetToken($email: String!, $otp: String!) {
    verifyResetToken(email: $email, otp: $otp)
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($email: String!, $otp: String!, $password: String!) {
    resetPassword(email: $email, otp: $otp, password: $password)
  }
`;

export const LOGIN_AS_USER = gql`
  mutation LoginAsUser($email: String!, $password: String!) {
    loginAsUser(email: $email, password: $password) {
      token
      otpRequired
      user {
        dob
        email
        firstName
        emailVerifiedAt
        emailOtpEnabled
        id
        lastName
        role
        store {
          id
          name
          status
        }
      }
    }
  }
`;

export const GET_ADMIN_INFO = gql`
  query Me {
    me {
      id
      role
      firstName
      lastName
      profilePic
      dob
      email
      emailVerifiedAt
      country
      countryCode
      phone
      phoneVerifiedAt
      createdAt

      store {
        id
        name
        coverPic
        description
        Address {
          id

          country
          zipCode
          countryCode
          phone
          personName
          lon
          lat
          createdAt
        }

        subscriptions {
          id
          isActive
          expiredAt
          Package {
            id
            name
            price
          }
        }
      }
    }
  }
`;

export const sendOTPToEnableEmail2Factor = gql`
  mutation SendOTPToEnableEmail2Factor {
    sendOTPToEnableEmail2Factor
  }
`;
export const EnableEmail2factor = gql`
  mutation Mutation($otp: String!) {
    enableEmail2Factor(otp: $otp)
  }
`;
export const sendOTPToDisableEmail2Factor = gql`
  mutation SendOTPToDisableEmail2Factor {
    sendOTPToDisableEmail2Factor
  }
`;
export const DisableEmail2factor = gql`
  mutation Mutation($otp: String!) {
    disableEmail2Factor(otp: $otp)
  }
`;


export const LoginWithOTP = gql`
  mutation LoginAsUserWithOtp($email: String!, $otp: String!) {
    loginAsUserWithOtp(email: $email, otp: $otp) {
      token
      user {
        id
        role
        firstName
        lastName
        profilePic
        dob
        email
        emailVerifiedAt
        country
        emailOtpEnabled
        countryCode
        phone
        phoneVerifiedAt
        createdAt
        store {
          id
          name
          coverPic
          description
          Address {
            id
            street
            street2
            city
            state
            country
            zipCode
            countryCode
            phone
            personName
            lon
            lat
            createdAt
          }

          subscriptions {
            id
            isActive
            expiredAt
            Package {
              id
              name
              price
            }
          }
        }
      }
    }
  }
`;
